module.exports = __webpack_public_path__ + "media/images/home/rain-842579c95efc5047a64c55e7f6053e61.jpg";